<template>
	<td v-if="!hidden && removed.indexOf(pos) === -1"><span><slot></slot></span></td>
	<tr v-else-if="hidden && removed.indexOf(pos) >= 0">
		<td>{{ label }}</td>
		<td><slot></slot></td>
	</tr>
</template>

<script>
	export default {
		props: ['pos', 'hidden', 'label'],
		computed: {
			removed() {
				return this.$parent.$parent.removed;
			}
		}
	}
</script>